import React from "react";
import degrillage from "../../images/icons/degrillage.png";
import dessablage from "../../images/icons/dessablage.png";
import bio from "../../images/icons/bio.png";
import eau from "../../images/icons/eauu.png";
import eaux from "../../images/icons/eauxx.png";

const MissionCards = () => {
  const treatmentSteps = [
    {
      title: "Dégrillage",
      icon: <img src={degrillage} className="w-24 h-24" />,
      description:
        "Cette première étape élimine les déchets solides (plastiques, lingettes, etc.) grâce à des grilles mécaniques.",
    },
    {
      title: "Déshuilage / Dessablage",
      icon: <img src={dessablage} className="w-24 h-24" />,
      description:
        "Les huiles, graisses et sables sont extraits par décantation et insufflation d'air, allégeant ainsi l'eau pour le traitement suivant.",
    },
    {
      title: "Traitement Biologique",
      icon: <img src={bio} className="w-24 h-24" />,
      description:
        "Les micro-organismes dégradent la matière organique dissoute pour purifier l'eau, en imitant les processus naturels.",
    },
    {
      title: "Traitement Membranaire",
      icon: <img src={eau} className="w-24 h-24" />,
      description:
        "Des membranes filtrantes retiennent les résidus encore présents, tels que les virus ou bactéries, assurant une qualité d'eau maximale.",
    },
  ];

  return (
    <div className="max-w-6xl min-h-screen p-6 mx-auto bg-gray-50">
      {/* Main Treatment Steps */}
      <div className="grid grid-cols-1 gap-6 mb-8 md:grid-cols-2 lg:grid-cols-4">
        {treatmentSteps.map((step, index) => (
          <div
            key={index}
            className="p-6 text-center border border-green-100 rounded-lg bg-green-50"
          >
            <div className="flex justify-center mb-4">{step.icon}</div>
            <h3 className="mb-3 text-lg font-semibold text-teal-700">
              {step.title}
            </h3>
            <p className="text-sm leading-relaxed text-gray-700">
              {step.description}
            </p>
          </div>
        ))}
      </div>

      {/* Final Discharge Step */}
      <div className="flex justify-center">
        <div className="max-w-md p-6 text-center border border-green-100 rounded-lg bg-green-50">
          <div className="flex justify-center mb-4">
            <div className="flex items-center justify-center ">
              <img src={eaux} className="w-24 h-24" />
            </div>
          </div>
          <h3 className="mb-3 text-lg font-semibold text-teal-700">
            Rejet dans le Ru de Gally
          </h3>
          <p className="text-sm leading-relaxed text-gray-700">
            Une fois purifiée, l'eau est rejetée en toute sécurité dans le ru de
            Gally, contribuant à l'équilibre du milieu naturel.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MissionCards;
